import React from "react";
import { useFormContext } from "react-hook-form";
import * as yup from "yup";

import { usePlacesOptions } from "api/hooks";
import { COURSE_PLACE_TYPE, COURSE_PLACE_TYPE_OPTIONS } from "consts/courseScheduleType";
import { PaziaSelect } from "components/atoms";

export const BasePlaceScheduleForm = (): JSX.Element => {
  const { watch } = useFormContext();

  const { loading: loadingPlaces, options: placesOptions } = usePlacesOptions();
  const isOnSite =
    watch(BASE_PLACE_FORM_NAMES.PLACE_TYPE) == COURSE_PLACE_TYPE.ONSITE.toString() ||
    watch(BASE_PLACE_FORM_NAMES.PLACE_TYPE) == COURSE_PLACE_TYPE.USER_CHOICE.toString();

  placesOptions?.unshift({ value: "-1", label: "⌛ Nieokreślone - ustaw później" });
  return (
    <>
      <div className="col-span-5 col-start-1">
        <PaziaSelect
          name={BASE_PLACE_FORM_NAMES.PLACE_TYPE}
          options={COURSE_PLACE_TYPE_OPTIONS}
          label="Typ zjazdu"
          required
        />
      </div>
      {isOnSite && (
        <div className="col-span-7">
          <PaziaSelect
            options={placesOptions}
            name={BASE_PLACE_FORM_NAMES.PLACE}
            label="Miejsce"
            required
            isLoading={loadingPlaces}
          />
        </div>
      )}
    </>
  );
};

const BASE_PLACE_FORM_NAMES = {
  PLACE_TYPE: "placeType",
  PLACE: "place",
} as const;

const basePlaceScheduleSchema = yup
  .object({
    [BASE_PLACE_FORM_NAMES.PLACE_TYPE]: yup.string().required(),
    [BASE_PLACE_FORM_NAMES.PLACE]: yup.string().when(BASE_PLACE_FORM_NAMES.PLACE_TYPE, {
      is: (placeType: number) => placeType == COURSE_PLACE_TYPE.ONSITE || placeType == COURSE_PLACE_TYPE.USER_CHOICE,
      then: (shema) => shema.required(),
    }),
  })
  .required();

const resolveDefaultValues = (model?: { placeType: number; placeId?: number }) => {
  return {
    [BASE_PLACE_FORM_NAMES.PLACE_TYPE]: model?.placeType?.toString() ?? undefined,
    [BASE_PLACE_FORM_NAMES.PLACE]: model?.placeId?.toString() ?? undefined,
  };
};

export type BasePlaceScheduleFormSchema = yup.InferType<typeof basePlaceScheduleSchema>;

export const ScheduleFormPlace = {
  schema: basePlaceScheduleSchema,
  fields: BASE_PLACE_FORM_NAMES,
  resolveDefaultValues,
};
